import script from "./PoleGroupUpdateDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoleGroupUpdateDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PoleGroupUpdateDialog.vue?vue&type=style&index=0&id=3f1080a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1080a9"]])

export default __exports__